import Resource from 'Resources/Resource';
import AppService from 'App/legacy/AppService';
import type AccountProfile from 'App/resources/Model/AccountProfile';

type RawAccountProfile = {
	alias: string;
	id: number;
	value: string;
};

class AccountProfileResource extends Resource {
	constructor() {
		super('accountProfile', null, { notificationTitle: 'admin.accountProfile' });
	}

	parse(data: RawAccountProfile | RawAccountProfile[] | AccountProfile): AccountProfile | null {
		// This is for the new domain layer that returns an array in find
		if (Array.isArray(data)) {
			return data.length ? this.parse(data[0]) : null;
		}

		// Make sure we did not get a clientParam object
		const raw = data as RawAccountProfile;
		if (data && !raw.alias && !raw.value) {
			return data as AccountProfile;
		}

		// Set profile to null if parse failed
		let json = null;
		try {
			json = JSON.parse(raw.value);
		} catch {
			// if parsing fails, the json will be null
		}

		if (json) {
			if (!json.extraColors) {
				json.extraColors = [];
			}

			if (json.typography) {
				Object.keys(json.typography).forEach(key => {
					if (!json.typography[key].fontFamily) {
						json.typography[key].fontFamily = 'Arial, Helvetica, sans-serif';
					}
				});
			}

			if (!json.colors.footerLinkText) {
				json.colors.footerLinkText = json.colors.linkText;
			}
			if (!json.colors.footerText) {
				json.colors.footerText = json.colors.mainText;
			}
		}

		return json;
	}

	new() {
		const accountSelf = AppService.getAccountSelf();

		const profile = {
			name: accountSelf.client.name,
			address: '',
			zipcode: '',
			city: '',
			country: '',
			email: '',
			phone: '',
			logo: '',
			darkLogo: '',
			btnBorderRadius: 3,
			extraColors: [{ value: '#002f65' }, { value: '#4a90e2' }, { value: '#F6F9FB' }, { value: '#E4EAF0' }],
			colors: {
				mainBg: '#002f65',
				mainText: '#2F3947',
				bodyBg: '#E4EAF0',
				contentBg: '#ffffff',
				contentText: '#6B7C93',
				contentTextIngress: '#2F3947',
				buttonBg: '#F5A623',
				buttonText: '#ffffff',
				secondaryBg: '#A4B3C7',
				secondaryText: '#002f65',
				linkText: '#4A90E2',
				footerLinkText: '#4A90E2',
				footerText: '#000000'
			},
			typography: {
				h2: {
					size: 32,
					bold: false,
					underline: false,
					italic: false,
					fontFamily: 'Arial, Helvetica, sans-serif'
				},
				h3: {
					size: 20,
					bold: false,
					underline: false,
					italic: false,
					fontFamily: 'Arial, Helvetica, sans-serif'
				},
				ingress: {
					size: 16,
					bold: false,
					underline: false,
					italic: false,
					fontFamily: 'Arial, Helvetica, sans-serif'
				},
				p: {
					size: 14,
					bold: false,
					underline: false,
					italic: false,
					fontFamily: 'Arial, Helvetica, sans-serif'
				},
				link: {
					size: 14,
					bold: false,
					underline: false,
					italic: true,
					fontFamily: 'Arial, Helvetica, sans-serif'
				}
			}
		};

		return profile;
	}
}

const resource = new AccountProfileResource();

export default resource;
